module.exports = __webpack_public_path__ + "img/defaultCoinIco.006b0a19.png";